var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52832 11.4997L3.6812 14.7266C3.84546 18.1683 3.92759 19.8891 5.08717 20.9444C6.24675 21.9997 8.05548 21.9997 11.6729 21.9997H13.3837C17.0011 21.9997 18.8099 21.9997 19.9695 20.9444C21.129 19.8891 21.2112 18.1683 21.3754 14.7266L21.5283 11.4997",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3755 10.9428C5.0748 14.1741 8.90752 15.4997 12.5283 15.4997C16.1491 15.4997 19.9818 14.1741 21.6811 10.9428C22.4923 9.40031 21.8781 6.49975 19.8803 6.49975H5.17632C3.17855 6.49975 2.56435 9.40031 3.3755 10.9428Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5283 11.4997H12.5373",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5283 6.49975L16.44 6.19069C16 4.65064 15.78 3.88062 15.2562 3.44018C14.7324 2.99975 14.0367 2.99975 12.6452 2.99975H12.4113C11.0199 2.99975 10.3242 2.99975 9.80042 3.44018C9.27664 3.88062 9.05663 4.65064 8.61662 6.19069L8.52832 6.49975",
    stroke: "#141B34",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a058871d26b4930f1f1e5cd52352b154.svg";
export { ForwardRef as ReactComponent };